import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-boldest" }, "Latest Authors Sales", -1)
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = {
  class: "btn btn-sm btn-icon btn-circle btn-icon-success btn-active-light-success",
  href: "#",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_create_account"
}
const _hoisted_5 = {
  "data-bs-toggle": "tooltip",
  "data-bs-trigger": "hover",
  title: "Add New User"
}
const _hoisted_6 = { class: "svg-icon svg-icon-2" }
const _hoisted_7 = {
  class: "btn btn-sm btn-icon btn-circle btn-icon-primary btn-active-light-primary",
  href: "#",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_new_card"
}
const _hoisted_8 = {
  "data-bs-toggle": "tooltip",
  "data-bs-trigger": "hover",
  title: "Add New Card"
}
const _hoisted_9 = { class: "svg-icon svg-icon-1" }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = {
  class: "btn btn-sm btn-icon btn-circle btn-icon-danger btn-active-light-danger",
  href: "#",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_12 = { class: "svg-icon svg-icon-1" }
const _hoisted_13 = { class: "card-body pt-1" }
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<ul class=\"nav rounded-pill flex-center bg-light overflow-auto flex-nowrap p-2 mb-8\"><li class=\"nav-item flex-equal\"><a class=\"nav-link btn btn-active-white btn-color-gray-500 btn-active-color-gray-700 py-2 px-4 fs-6 fw-bold active\" data-bs-toggle=\"tab\" href=\"#kt_lists_widget_3_tab_pane_1\"> Exclusive Authors </a></li><li class=\"nav-item flex-equal mx-1\"><a class=\"nav-link btn btn-active-white btn-color-gray-500 btn-active-color-gray-700 py-2 px-4 fs-6 fw-bold\" data-bs-toggle=\"tab\" href=\"#kt_lists_widget_3_tab_pane_2\"> Statistics </a></li><li class=\"nav-item flex-equal\"><a class=\"nav-link btn btn-active-white btn-color-gray-500 btn-active-color-gray-700 py-2 px-4 fs-6 fw-bold\" data-bs-toggle=\"tab\" href=\"#kt_lists_widget_3_tab_pane_3\"> Recent Trends </a></li></ul>", 1)
const _hoisted_15 = { class: "tab-content" }
const _hoisted_16 = {
  class: "tab-pane fade active show",
  id: "kt_lists_widget_3_tab_pane_1"
}
const _hoisted_17 = { class: "mb-7" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-4 text-gray-400 mb-5" }, "24 Sep, 2021", -1)
const _hoisted_19 = { class: "overflow-auto mb-10" }
const _hoisted_20 = { class: "symbol symbol-40px symbol-circle me-4" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "d-flex flex-column min-w-150px me-4" }
const _hoisted_23 = {
  href: "#",
  class: "fw-boldest text-gray-800 text-hover-primary fs-4"
}
const _hoisted_24 = { class: "fw-bold fs-6 text-gray-400" }
const _hoisted_25 = { class: "ms-auto rounded-pill bg-light fw-bolder text-gray-600 py-1 px-3" }
const _hoisted_26 = { class: "mb-7" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-4 text-gray-400 mb-5" }, "30 Sep, 2021", -1)
const _hoisted_28 = { class: "overflow-auto" }
const _hoisted_29 = { class: "symbol symbol-40px symbol-circle me-4" }
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "d-flex flex-column min-w-150px me-4" }
const _hoisted_32 = {
  href: "#",
  class: "fw-boldest text-gray-800 text-hover-primary fs-4"
}
const _hoisted_33 = { class: "fw-bold fs-6 text-gray-400" }
const _hoisted_34 = { class: "ms-auto rounded-pill bg-light fw-bolder text-gray-600 py-1 px-3" }
const _hoisted_35 = {
  class: "tab-pane fade",
  id: "kt_lists_widget_3_tab_pane_2"
}
const _hoisted_36 = {
  class: "tab-pane fade",
  id: "kt_lists_widget_3_tab_pane_3"
}
const _hoisted_37 = { class: "mb-0" }
const _hoisted_38 = { class: "symbol symbol-50px symbol-circle me-5" }
const _hoisted_39 = { class: "symbol-label" }
const _hoisted_40 = ["src"]
const _hoisted_41 = { class: "d-flex align-items-center flex-row-fluid flex-wrap" }
const _hoisted_42 = { class: "flex-grow-1 me-2" }
const _hoisted_43 = {
  href: "#",
  class: "text-gray-800 text-hover-primary fs-6 fw-bolder"
}
const _hoisted_44 = { class: "text-muted fw-bold d-block fs-7" }
const _hoisted_45 = { class: "badge badge-light fw-bolder my-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown1 = _resolveComponent("Dropdown1")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card card-flush"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen035.svg" })
            ])
          ])
        ]),
        _createElementVNode("a", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen006.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("a", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen023.svg" })
            ])
          ]),
          _createVNode(_component_Dropdown1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.authors1, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: _normalizeClass([[i !== _ctx.authors1.length - 1 && 'mb-7'], "d-flex align-items-center"])
                }, [
                  _createElementVNode("div", _hoisted_20, [
                    (item.user.src)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          alt: "Pic",
                          src: item.user.src
                        }, null, 8, _hoisted_21))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: _normalizeClass([`bg-light-${item.user.state} text-${item.user.state}`, "symbol-label fw-boldest"])
                        }, _toDisplayString(item.user.initials), 3))
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("a", _hoisted_23, _toDisplayString(item.title), 1),
                    _createElementVNode("div", _hoisted_24, _toDisplayString(item.subtitle), 1)
                  ]),
                  _createElementVNode("div", _hoisted_25, _toDisplayString(item.price), 1)
                ], 2))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.authors2, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: _normalizeClass([[i !== _ctx.authors2.length - 1 && 'mb-7'], "d-flex align-items-center"])
                }, [
                  _createElementVNode("div", _hoisted_29, [
                    (item.user.src)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          alt: "Pic",
                          src: item.user.src
                        }, null, 8, _hoisted_30))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: _normalizeClass([`bg-light-${item.user.state} text-${item.user.state}`, "symbol-label fw-boldest"])
                        }, _toDisplayString(item.user.initials), 3))
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("a", _hoisted_32, _toDisplayString(item.title), 1),
                    _createElementVNode("div", _hoisted_33, _toDisplayString(item.subtitle), 1)
                  ]),
                  _createElementVNode("div", _hoisted_34, _toDisplayString(item.price), 1)
                ], 2))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createVNode(_component_apexchart, {
            type: "bar",
            height: "350",
            options: _ctx.chartOptions,
            series: _ctx.series
          }, null, 8, ["options", "series"])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trends, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: _normalizeClass([[i !== _ctx.trends.length - 1 && 'mb-7'], "d-flex align-items-sm-center"])
              }, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("span", _hoisted_39, [
                    _createElementVNode("img", {
                      src: item.image,
                      class: "h-50 align-self-center",
                      alt: ""
                    }, null, 8, _hoisted_40)
                  ])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("a", _hoisted_43, _toDisplayString(item.title), 1),
                    _createElementVNode("span", _hoisted_44, _toDisplayString(item.text), 1)
                  ]),
                  _createElementVNode("span", _hoisted_45, _toDisplayString(item.badge), 1)
                ])
              ], 2))
            }), 128))
          ])
        ])
      ])
    ])
  ], 2))
}